import React from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaLinkedinIn } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="w-full bg-[#0b1120] border-t border-slate-800/80 py-8 px-4 text-gray-400 text-sm">
            <div className="max-w-[1000px] mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
                <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-center sm:text-left">
                    <p>© {currentYear} Sharvan Samala. All rights reserved.</p>
                    <div className="flex items-center gap-4 text-xs">
                        <Link to="/privacy" className="hover:text-[#64ffda] transition-colors">
                            Privacy Policy
                        </Link>
                        <span>•</span>
                        <Link to="/terms" className="hover:text-[#64ffda] transition-colors">
                            Terms & Conditions
                        </Link>
                    </div>
                </div>

                <div className="flex items-center space-x-6">
                    <a
                        href="https://github.com/Sharvansamala"
                        target="_blank"
                        rel="noreferrer noopener"
                        aria-label="GitHub Profile"
                        className="hover:text-[#64ffda] transition-colors"
                    >
                        <FaGithub size={20} />
                    </a>
                    <a
                        href="https://www.linkedin.com/in/sharvansamala"
                        target="_blank"
                        rel="noreferrer noopener"
                        aria-label="LinkedIn Profile"
                        className="hover:text-[#64ffda] transition-colors"
                    >
                        <FaLinkedinIn size={20} />
                    </a>
                    <a
                        href="mailto:samalasharvan@gmail.com"
                        aria-label="Send Email"
                        className="hover:text-[#64ffda] transition-colors"
                    >
                        <HiOutlineMail size={22} />
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
